var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.logo)?_c('div',{staticClass:"ob-brand",attrs:{"data-testid":"organization-brand"}},[_c('img',{staticClass:"ob-logo",attrs:{"src":_vm.logo,"alt":`${_vm.accountName || 'Account'} logo`,"data-testid":"organization-brand-logo"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }